import config from './config';

function getGameSpecsApi(params) {
  	return Ajax.get(config.listGameSpecs, params);	
}

function createGameInstanceApi(params) {
    return Ajax.post(config.createGameInstance, params,{
        headers: {
            'Content-Type': 'application/json'
        }
    });  
}
function getGameInstancesApi(params) {
    return Ajax.get(config.listGameInstances, params);	
}
export {
	getGameSpecsApi,
    createGameInstanceApi,
    getGameInstancesApi
};


// WEBPACK FOOTER //
// ./src/api/game/actions.js